import * as types from '../mutation-types'

// initial state
const state = {
  mobile: false,
  navbar: false,
  scrollEnabled: true
  // sidebar: false
}

// mutations
const mutations = {
  [types.SET_MOBILE] (state, action) {
    state.mobile = action
  },

  [types.SET_NAVBAR] (state, action) {
    state.navbar = action
  },

  [types.ACTIVATE_SCROLL] (state, action) {
    state.scrollEnabled = true
  },

  [types.DEACTIVATE_SCROLL] (state, action) {
    state.scrollEnabled = false
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js